import { readAttribute } from './cookies'

/**
 * Returns the google analytics client id
 */
export const getGAClientID = () => {
    // If Google Analitics is loaded (ga) read from local library
    try {
        // @ts-ignore
        const googleAnalyticsClientId = ga.getAll()[0].get('clientId')
        if (googleAnalyticsClientId) {
            return googleAnalyticsClientId
        }
    } catch (e) {}

    // alternatively read from cookie
    try {
        return readAttribute('_ga', 2) + '.' + readAttribute('_ga', 3)
    } catch (err) {
        return ''
    }
}
